import { Colors, FlexBox, FormError, InlineText, Label, TextArea, TextAreaProps } from '@helloself/hello-self-ui';
import { FormikProps } from 'formik';
import React from 'react';

import { ProfileFormValues } from '../EditModal';

type Props = Pick<
    FormikProps<ProfileFormValues>,
    'values' | 'setFieldValue' | 'handleBlur' | 'errors' | 'touched' | 'setFieldTouched'
> &
    Pick<TextAreaProps, 'height'> & {
        name: keyof ProfileFormValues;
        label: string;
        limit: number;
        placeholder: string;
    };

export function TextAreaWithCount({
    name,
    label,
    limit,
    placeholder,
    values,
    height = '104px',
    setFieldValue,
    handleBlur,
    setFieldTouched,
    errors,
    touched,
}: Props) {
    return (
        <FlexBox flexDirection="column">
            <Label htmlFor={name}>{label}</Label>
            <TextArea
                id={name}
                height={height}
                padding="8px 12px 8px 12px"
                onBlur={handleBlur}
                value={values[name]}
                onChange={({ currentTarget }) => {
                    setFieldTouched(name, true);
                    setFieldValue(name, currentTarget.value);
                }}
                placeholder={placeholder}
                isInvalid={!!errors[name] && !!touched[name]}
            />
            <FlexBox marginTop="2px" width="100%">
                {errors[name] && touched[name] && (
                    <FormError textSize="small" margin="0">
                        {errors[name]}
                    </FormError>
                )}
                <FlexBox flex="1" justifyContent="flex-end">
                    <InlineText
                        textColor={errors[name] && touched[name] ? Colors.pink : Colors.MemberGreen500}
                        fontSize="14px"
                        lineHeight="18px"
                        margin="0"
                        padding="0"
                    >
                        {values[name].length}/{limit}
                    </InlineText>
                </FlexBox>
            </FlexBox>
        </FlexBox>
    );
}
